import { render } from "./DeleteVideoModal.vue?vue&type=template&id=326b5ef4&scoped=true"
import script from "./DeleteVideoModal.vue?vue&type=script&lang=js"
export * from "./DeleteVideoModal.vue?vue&type=script&lang=js"

import "./DeleteVideoModal.vue?vue&type=style&index=0&id=326b5ef4&scoped=true&lang=css"

import exportComponent from "/Users/apple/Desktop/projects/Active Projects/EIEV/Media Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326b5ef4"]])

export default __exports__